import { isUserAuthorized } from "."

export default ({ enabledFeatures, permissions }) => {
  const isAuthorized = isUserAuthorized({ enabledFeatures, permissions })
  const hasYourPerformance =
    permissions.products &&
    (permissions.products.xtm || permissions.products.xtp)

  return isAuthorized && hasYourPerformance
}
